module.exports = __webpack_public_path__ + "static/media/vl.82b851ff.jpg";